import React from "react";
import { Button } from "../components/ui/button";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { CONTACT, BRAND, LINKS } from "../mock";
import ImpressumLinks from "./ImpressumLinks";

export default function Contact() {
  return (
    <section id="kontakt" className="bg-[#f5f7f8] text-neutral-900 border-t border-black/10">
      <div className="mx-auto max-w-7xl px-6 py-16 grid grid-cols-1 md:grid-cols-2 gap-10">
        <div>
          <h2 className="text-3xl md:text-4xl font-bold">Kontakt</h2>
          <p className="mt-2 text-neutral-600">
            Wir sind für dich da – schnell, digital und transparent.
          </p>

          <div className="mt-6 space-y-3 text-sm">
            <a href={LINKS.whatsappLink} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-[var(--brand-red)] hover:underline">
              <MessageCircle className="h-4 w-4" /> WhatsApp: {CONTACT.whatsappIntl}
            </a>
            <a href={LINKS.telLink} className="flex items-center gap-2 text-neutral-700 hover:text-neutral-900">
              <Phone className="h-4 w-4" /> Telefon: {CONTACT.phoneIntl}
            </a>
            <a href={LINKS.mailLink} className="flex items-center gap-2 text-neutral-700 hover:text-neutral-900">
              <Mail className="h-4 w-4" /> {CONTACT.email}
            </a>
            <p className="flex items-start gap-2 text-neutral-600">
              <MapPin className="mt-0.5 h-4 w-4" /> {BRAND.addressLine}
            </p>
          </div>
        </div>

        <div className="flex items-center justify-center">
          <Button
            asChild
            className="w-full md:w-auto px-8 md:px-12 h-16 md:h-20 text-lg md:text-2xl rounded-xl bg-[#25D366] hover:bg-[#1ebe5d] text-white transition-transform duration-200 active:scale-[0.99] flex items-center gap-3"
          >
            <a href={LINKS.whatsappLink} target="_blank" rel="noreferrer">
              <svg className="h-7 w-7" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.520-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.064 3.488"/>
              </svg>
              WhatsApp
            </a>
                </Button>
              </div>
      </div>

      {/* Footer inside contact section */}
      <div className="border-t border-black/10 bg-[#f5f7f8]">
        <div className="mx-auto max-w-7xl px-6 py-8 text-sm text-neutral-600 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-center gap-6 flex-wrap">
            <ImpressumLinks />
            <span className="text-neutral-400">|</span>
            <a href="https://haksportcars.de" target="_blank" rel="noreferrer" className="hover:text-neutral-900" style={{ fontFamily: 'Caveat, cursive', color: '#0b0b0c', fontSize: '1.25rem' }}>
              Bekannt durch: HAK Sportcars – Sportwagenvermietung
            </a>
          </div>
          <div>
            © {new Date().getFullYear()} {BRAND.name}. {BRAND.owner}. Alle Rechte vorbehalten.
          </div>
        </div>
      </div>
    </section>
  );
}